import { render, staticRenderFns } from "./OtherLoginType.vue?vue&type=template&id=6dcc5746&scoped=true"
import script from "./OtherLoginType.vue?vue&type=script&lang=js"
export * from "./OtherLoginType.vue?vue&type=script&lang=js"
import style0 from "./OtherLoginType.vue?vue&type=style&index=0&id=6dcc5746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcc5746",
  null
  
)

export default component.exports